import { useDispatch } from "react-redux";
import { default as credentialsService } from "../services/credentials";
import { defineToken, undefineToken } from "../utils/token";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { loginFailure, loginRequest, loginSuccess } from "../actions";
import { CredentialsLoginParam } from "../types/credentials";
import { AxiosError } from "axios";
import useI18n from "@/hooks/useI18n";
import { getLangCode } from "@/i18n";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";

const useCredentials = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const Settings = useSettingsContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();
  const { changeLang } = useI18n();

  // TODO: Merge with the one in AuthenticationProvider in a new hook
  const handleRedirectLogIn = () => {
    const {
      redirectPath, pathParams, ...restSearchParams
    } = Object.fromEntries(searchParams);

    if (redirectPath) {
      navigate(
        t(
          redirectPath, 
          pathParams ? JSON.parse(pathParams) : {}
        ) + createSearchParams(restSearchParams).toString()
      );
    } else {
      navigate(t(`common:url.${Settings.homepage ?? "invoices"}`));
    }
  }

  const loginCredentials = ({
    user, 
    password
  }: CredentialsLoginParam) => {
    dispatch(loginRequest("USER_AND_PASSWORD"));
    credentialsService.loginCredentials({user, password})
    .then(response => {
      if (response.token) {

        const { locale } = defineToken(response.token);
        changeLang(getLangCode(locale));
        dispatch(loginSuccess());
        if (response.change_password) {
          navigate({
            pathname: t("common:url.changePassword") as string,
            search: createSearchParams(searchParams).toString()
          });
        } else {
          handleRedirectLogIn();
        }

      } else {
        dispatch(loginFailure({
          statusCode: 401,
          status: "error"
       }));
      }
    }).catch((error: AxiosError) => {
      undefineToken();
      dispatch(loginFailure({
        statusCode: 401,
        status: "error"
      }));
    });
  }

  return {
    loginCredentials
  }
};

export default useCredentials;